import { render } from "./DeleteReportComponent.vue?vue&type=template&id=238ccd97"
import script from "./DeleteReportComponent.vue?vue&type=script&lang=js"
export * from "./DeleteReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__